import * as React from 'react'

const Close = (props: any) => (
  <svg {...props} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.62602 5.78919L11.8537 1.54054C12.0488 1.34595 12.0488 1.05405 11.8537 0.859459L11.2033 0.178378C11.0081 -0.0162162 10.7154 -0.0162162 10.5203 0.178378L6.26016 4.42703C6.13008 4.55676 5.93496 4.55676 5.80488 4.42703L1.54472 0.145946C1.34959 -0.0486487 1.05691 -0.0486487 0.861789 0.145946L0.178862 0.827027C-0.0162602 1.02162 -0.0162602 1.31351 0.178862 1.50811L4.43902 5.75676C4.56911 5.88649 4.56911 6.08108 4.43902 6.21081L0.146341 10.4919C-0.0487805 10.6865 -0.0487805 10.9784 0.146341 11.173L0.829268 11.8541C1.02439 12.0486 1.31707 12.0486 1.5122 11.8541L5.77236 7.6054C5.90244 7.47568 6.09756 7.47568 6.22764 7.6054L10.4878 11.8541C10.6829 12.0486 10.9756 12.0486 11.1707 11.8541L11.8537 11.173C12.0488 10.9784 12.0488 10.6865 11.8537 10.4919L7.62602 6.24324C7.49594 6.11351 7.49594 5.91892 7.62602 5.78919Z'
    />
  </svg>
)

export default Close



// WEBPACK FOOTER //
// ./src/components/icons/ui/Close.tsx